import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../BaseComponentWrappers/MotifButton';
import StyledFitButton from './StyledFitButton';

export default function FitButton({onClick, disabled, label, icon, variant, children, size}) {
	const props = {
		type: 'button',
		variant,
		disabled,
		showLabel: !!label,
		showIcon: !!icon,
		children,
		size
	};

	if (onClick) props.onClick = onClick;
	if (label) props.buttonLabel = label;
	if (icon) props.iconSource = icon;

	return (
		<StyledFitButton className={classNames({['fb-label']: !!label, ['fb-icon']: !!icon})}>
			<Button {...props} />
		</StyledFitButton>
	);
}

FitButton.propTypes = {
	variant: PropTypes.oneOf(['primary', 'primary', 'secondary']),
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	label: PropTypes.string,
	icon: PropTypes.string
};

FitButton.defaultProps = {
	variant: 'secondary',
	onClick: null,
	disabled: false,
	label: null,
	icon: null
};
